import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.en.mdx';

export const title = 'Number of sales by campaign (Chart)';

Chart showing the number of sales attributed to campaigns.

<CampaignAttributionDateNote />
